import React, { Component } from "react";
import {
  Card,
  CardBody,
  Copy,
  Bold,
  Wrapper,
  Row,
  Spin,
  Icon
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";
import { renderPrice } from "app/NativeActions";
class PayNowCard extends Component {
  renderExtraFee(slug) {
    const { estimated_payment } = this.props;
    if (
      estimated_payment[slug].extra_fee_text &&
      estimated_payment[slug].extra_fee
    ) {
      return (
        <Row>
          <Wrapper style={{ flex: 1, paddingRight: 20 }}>
            <Copy>{estimated_payment[slug].extra_fee_text}</Copy>
          </Wrapper>
          <Wrapper>
            <Copy>{renderPrice(estimated_payment[slug].extra_fee)}</Copy>
          </Wrapper>
        </Row>
      );
    }
  }

  renderPayment(engine_slug) {
    const { estimated_payment, plan_info, colors } = this.props;

    let slug = engine_slug;
    if (slug == "driving") {
      slug = "street";
    }
    if (plan_info) {
      if (estimated_payment[slug] && estimated_payment[slug].selected_engine) {
        let title = "Your monthly subscription";
        let per = "mo";
        if (estimated_payment[slug].frequency == "annually") {
          title = "Your annual subscription";
          per = "yr";
        }
        return (
          <Wrapper>
            <Wrapper style={{ marginBottom: 10 }}>
              <Copy>
                <Bold>{title}</Bold>
              </Copy>
            </Wrapper>
            <Wrapper style={{ marginBottom: 10 }}>
              <Row>
                <Wrapper style={{ flex: 1, paddingRight: 20 }}>
                  <Copy>{plan_info.fields.title}</Copy>
                </Wrapper>
                <Wrapper>
                  <Copy>
                    {renderPrice(
                      estimated_payment[slug].original_charge_amount
                    ) +
                      "/" +
                      per}
                  </Copy>
                </Wrapper>
              </Row>

              {estimated_payment[slug].coupon_info &&
              estimated_payment[slug].coupon_info.has_coupon &&
              estimated_payment[slug].coupon_info.amount_off > 0 ? (
                <Row>
                  <Wrapper style={{ flex: 1, paddingRight: 20 }}>
                    <Copy>
                      Promo code: {estimated_payment[slug].coupon_info.promo}
                    </Copy>
                  </Wrapper>
                  <Wrapper>
                    <Copy>
                      {renderPrice(
                        estimated_payment[slug].coupon_info.amount_off
                      ) +
                        " off per " +
                        per}
                    </Copy>
                  </Wrapper>
                </Row>
              ) : null}

              {estimated_payment[slug].free_trial_length > 0 &&
              estimated_payment[slug].is_free_trial ? (
                <Wrapper
                  style={{
                    marginTop: 15,
                    paddingTop: 15,
                    borderTopColor: colors.border_color,
                    borderTopStyle: "solid",
                    borderTopWidth: 1
                  }}
                >
                  <Row>
                    <Wrapper style={{ flex: 1, paddingRight: 20 }}>
                      <Copy>
                        {estimated_payment[slug].free_trial_days_left <
                        estimated_payment[slug].free_trial_length
                          ? "Total after your " +
                            estimated_payment[slug].free_trial_length +
                            " day free trial (" +
                            estimated_payment[slug].free_trial_days_left +
                            " day(s) remaining):"
                          : "Total after your " +
                            estimated_payment[slug].free_trial_length +
                            " day free trial:"}
                      </Copy>
                    </Wrapper>
                    <Wrapper>
                      <Copy>
                        {renderPrice(estimated_payment[slug].charge_amount)}
                      </Copy>
                    </Wrapper>
                  </Row>
                  {this.renderExtraFee(slug)}

                  <Row>
                    <Wrapper style={{ flex: 1, paddingRight: 20 }}>
                      <Copy>
                        <Bold>{"Total today:"}</Bold>
                      </Copy>
                    </Wrapper>
                    <Wrapper>
                      <Copy>
                        <Bold>
                          {renderPrice(
                            estimated_payment[slug].total_charge_today
                          )}
                        </Bold>
                      </Copy>
                    </Wrapper>
                  </Row>
                </Wrapper>
              ) : estimated_payment[slug].prorated > 0 ? (
                <Wrapper
                  style={{
                    marginTop: 15,
                    paddingTop: 15,
                    borderTopColor: colors.border_color,
                    borderTopStyle: "solid",
                    borderTopWidth: 1
                  }}
                >
                  <Row>
                    <Wrapper style={{ flex: 1, paddingRight: 20 }}>
                      <Copy>{"Prorated refund from previous payments:"}</Copy>
                    </Wrapper>
                    <Wrapper>
                      <Copy>
                        -{renderPrice(estimated_payment[slug].prorated)}
                      </Copy>
                    </Wrapper>
                  </Row>
                  {this.renderExtraFee(slug)}
                  <Row>
                    <Wrapper style={{ flex: 1, paddingRight: 20 }}>
                      <Copy>
                        <Bold>{"Total today:"}</Bold>
                      </Copy>
                    </Wrapper>
                    <Wrapper>
                      <Copy>
                        <Bold>
                          {renderPrice(
                            estimated_payment[slug].total_charge_today
                          )}
                        </Bold>
                      </Copy>
                    </Wrapper>
                  </Row>
                </Wrapper>
              ) : (
                <Wrapper>
                  {this.renderExtraFee(slug)}

                  <Row
                    style={{
                      marginTop: 15,
                      paddingTop: 15,
                      borderTopColor: colors.border_color,
                      borderTopStyle: "solid",
                      borderTopWidth: 1
                    }}
                  >
                    <Wrapper style={{ flex: 1, paddingRight: 20 }}>
                      <Copy>
                        <Bold>{"Total today:"}</Bold>
                      </Copy>
                    </Wrapper>
                    <Wrapper>
                      <Copy>
                        <Bold>
                          {renderPrice(
                            estimated_payment[slug].total_charge_today
                          )}
                        </Bold>
                      </Copy>
                    </Wrapper>
                  </Row>
                </Wrapper>
              )}
            </Wrapper>
          </Wrapper>
        );
      }
    }
  }

  renderPaymentButton() {
    const {
      cardCompleted,
      addressCompleted,
      editing_card,
      editing_address,
      card_info,
      address
    } = this.props;

    return (
      <Wrapper>
        <Row>
          <PillButton
            primary={true}
            style={{ marginLeft: 0 }}
            disabled={
              editing_card ||
              editing_address ||
              !cardCompleted(card_info) ||
              !addressCompleted(address)
            }
            onPress={() => {
              this.props.completePurchase();
            }}
          >
            Complete
          </PillButton>
        </Row>
      </Wrapper>
    );
  }

  render() {
    const {
      estimated_payment,
      loading_estimated_payment,
      engine_slug
    } = this.props;
    return (
      <Wrapper>
        <Card style={{ minWidth: 320, alignSelf: "auto" }}>
          <CardBody>
            {loading_estimated_payment ? (
              <Wrapper
                style={{ alignItems: "center", justifyContent: "center" }}
              >
                <Row>
                  <Spin size="small" />
                  <Copy style={{ marginLeft: 10 }}>
                    Loading subscription infomation...
                  </Copy>
                </Row>
              </Wrapper>
            ) : estimated_payment ? (
              <Wrapper>
                {this.renderPayment(engine_slug)}
                {this.renderPaymentButton()}
              </Wrapper>
            ) : null}
          </CardBody>
        </Card>
        <Wrapper
          style={{
            alignItems: "center",
            justifyContent: "center",
            padding: 10
          }}
        >
          <Row>
            <Icon icon="verified-user" size={14} style={{ marginRight: 5 }} />
            <Copy style={{ size: 14 }}>Securely encrypted payment</Copy>
          </Row>
        </Wrapper>
      </Wrapper>
    );
  }
}

export default PayNowCard;
